import { useCallback, useState } from "react";

export type SnackbarSeverity = "success" | "error" | "warning" | "info";

export type SnackbarState = {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
};

export const useSnackbar = (initial?: Partial<SnackbarState>) => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: initial?.severity ?? "success",
    ...initial,
  });

  const show = useCallback(
    (message: string, severity: SnackbarSeverity = "success") => {
      setSnackbar({ open: true, message, severity });
    },
    [],
  );

  const close = useCallback(
    (_evt?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === "clickaway") return;
      setSnackbar((s) => ({ ...s, open: false }));
    },
    [],
  );

  return { snackbar, show, close, setSnackbar };
};
